import { ErrorResponse } from '../models/shared';

export enum ErrorCode {
  TokenInvalid = 'TokenInvalid',
  EmailNotVerified = 'EmailNotVerified',
  InvalidBusinessId = 'InvalidBusinessId',
  UserHasNoBusiness = 'UserHasNoBusiness',
  UserDoesNotHavePermissionsForBusiness = 'UserDoesNotHavePermissionsForBusiness',
  UserDoesNotHavePermissionsForEvent = 'UserDoesNotHavePermissionsForEvent',
  ItemDoesNotHaveTicket = 'ItemDoesNotHaveTicket',
  OrderDoesNotHaveItems = 'OrderDoesNotHaveItems',
  OrderDoesNotHavePayments = 'OrderDoesNotHavePayments',
  OrderDoesNotHavePaymentToReimburse = 'OrderDoesNotHavePaymentToReimburse',
  OrderDoesNotHavePendingPayment = 'OrderDoesNotHavePendingPayment',
  OrderIdRequired = 'OrderIdRequired',
  VenueSeatNotFound = 'VenueSeatNotFound',
  EventSeatNotFound = 'EventSeatNotFound',
  EventSectorDoesNotBelongToEvent = 'EventSectorDoesNotBelongToEvent',
  EventHasNoVenue = 'EventHasNoVenue',
  UnknownError = 'UnknownError',
  UserNotFound = 'UserNotFound',
  EventNotFound = 'EventNotFound',
  OrderNotFound = 'OrderNotFound',
  TicketNotFound = 'TicketNotFound',
  ItemNotFound = 'ItemNotFound',
  PaymentNotFound = 'PaymentNotFound',
  AgentNotFound = 'AgentNotFound',
  DecodeError = 'DecodeError',
  QrCodeRevoked = 'QrCodeRevoked',
  NoPaidItemsFound = 'NoPaidItemsFound',
  TicketItemsMismatch = 'TicketItemsMismatch',
  NoTicketsLeft = 'NoTicketsLeft',
  MaxTicketsPerOrderExceeded = 'MaxTicketsPerOrderExceeded',
  MaxItemsPerPersonExceeded = 'MaxItemsPerPersonExceeded',
  TicketInactive = 'TicketInactive',
  NoCustomPrice = 'NoCustomPrice',
  InvalidCustomPrice = 'InvalidCustomPrice',
  InvalidCouponEvent = 'InvalidCouponEvent',
  UserAlreadyInvited = 'UserAlreadyInvited',
  UserAlreadyInBusiness = 'UserAlreadyInBusiness',
  InvitationNotFound = 'InvitationNotFound',
  CodeUsed = 'CodeUsed',
  InvalidOrderStatusTransition = 'InvalidOrderStatusTransition',
  ItemOtherEvent = 'ItemOtherEvent',
  ItemDoesNotHaveOrder = 'ItemDoesNotHaveOrder',
  SeatsHaveNoReservationCode = 'SeatsHaveNoReservationCode',
  ReservationNotFound = 'ReservationNotFound',
  ItemDoesNotHaveSeatOrTicket = 'ItemDoesNotHaveSeatOrTicket',
  OrderWithNoItems = 'OrderWithNoItems',
  SectorDoesNotMatch = 'SectorDoesNotMatch',
  SeatReservationMismatch = 'SeatReservationMismatch',
  SeatNotAvailable = 'SeatNotAvailable',
  VerificationCodeIncorrect = 'VerificationCodeIncorrect',
  BusinessNotFound = 'BusinessNotFound',
  CouponNotFound = 'CouponNotFound',
  ReservationExpired = 'ReservationExpired',
  EventSectorNotFound = 'EventSectorNotFound',
  MercadoPagoPreferenceCreationFailed = 'MercadoPagoPreferenceCreationFailed',
  MercadoPagoPaymentRetrievalFailed = 'MercadoPagoPaymentRetrievalFailed',
  UalaTokenRetrievalFailed = 'UalaTokenRetrievalFailed',
  UalaPaymentCreationFailed = 'UalaPaymentCreationFailed',
  PollResponsesNotFound = 'PollResponsesNotFound',
  ReferralNotFound = 'ReferralNotFound',
  SeatReservationNotFound = 'SeatReservationNotFound',
  FirebaseIdRequired = 'FirebaseIdRequired',
  CodeRequired = 'CodeRequired',
  PdfGenerationFailed = 'PdfGenerationFailed',
  TicketMailGenerationFailed = 'TicketMailGenerationFailed',
  VenueNotFound = 'VenueNotFound',
  Unauthorized = 'Unauthorized',
  UserEventNotFound = 'UserEventNotFound',
  UserBusinessNotFound = 'UserBusinessNotFound',
  UserDoesNotHavePermissionsForSeller = 'UserDoesNotHavePermissionsForSeller',
  SellerDoesNotHaveSummary = 'SellerDoesNotHaveSummary',
  EventTransactionNotFound = 'EventTransactionNotFound',
  NoBasePrice = 'NoBasePrice',
  ItemNotPaid = 'ItemNotPaid',
  OrderNotPaid = 'OrderNotPaid',
  FromBackofficeNotAllowed = 'FromBackofficeNotAllowed',
  InvalidSellerQrCode = 'InvalidSellerQrCode',
  UserEventDoesNotBelongToEvent = 'UserEventDoesNotBelongToEvent',
  EventDoesNotHaveSellerQr = 'EventDoesNotHaveSellerQr',
  TicketPrivileged = 'TicketPrivileged',
  NotImplemented = 'NotImplemented',
  PaymentConfigNotFound = 'PaymentConfigNotFound',
  MercadoPagoAccessTokenCreationFailed = 'MercadoPagoAccessTokenCreationFailed',
  MercadoPagoAlreadyAuthorized = 'MercadoPagoAlreadyAuthorized',
  BothEventsSame = 'BothEventsSame',
  WireTransferNotFound = 'WireTransferNotFound',
  ScanPeriodEarly = 'ScanPeriodEarly',
  ScanPeriodExpired = 'ScanPeriodExpired',
  TicketSaleNotStarted = 'TicketSaleNotStarted',
  TicketSaleEnded = 'TicketSaleEnded',
  SeatNotReserved = 'SeatNotReserved',
  InvalidReservationCode = 'InvalidReservationCode',
  DuplicateSeatsInOrder = 'DuplicateSeatsInOrder',
  OrderOtherEvent = 'OrderOtherEvent',
  OrderHasNoItems = 'OrderHasNoItems',
  NoFileProvided = 'NoFileProvided',
  ErrorUploadingFile = 'ErrorUploadingFile',
  SellerSalesNotEnabled = 'SellerSalesNotEnabled',
  CannotUpdatePriceWhenSold = 'CannotUpdatePriceWhenSold',
  CannotDeleteReferralWithTicketsSold = 'CannotDeleteReferralWithTicketsSold',
  CannotDeleteTicketWithTicketsSold = 'CannotDeleteTicketWithTicketsSold',
  CouponHasRelatedOrders = 'CouponHasRelatedOrders',
  CouponLimitBelowTaken = 'CouponLimitBelowTaken',
  CannotEditReferralWithTicketsSold = 'CannotEditReferralWithTicketsSold',
  CannotDeleteSellerWithSales = 'CannotDeleteSellerWithSales',
  CannotUpdateCommissionWithSales = 'CannotUpdateCommissionWithSales',
  CommissionNothingToPay = 'CommissionNothingToPay',
  CommissionBalanceChanged = 'CommissionBalanceChanged',
  CannotDeleteVenueWithSeats = 'CannotDeleteVenueWithSeats',
  CannotDeleteEventSectorWithSeats = 'CannotDeleteEventSectorWithSeats',
  InvalidId = 'InvalidId',
  TicketBelongsToOtherEvent = 'TicketBelongsToOtherEvent',
  OrderDoesNotBelongToEvent = 'OrderDoesNotBelongToEvent',
  FirebaseUpdateFailed = 'FirebaseUpdateFailed',
  UserNotAllowedToAccessResource = 'UserNotAllowedToAccessResource',
  CashierOrderNotAllowed = 'CashierOrderNotAllowed',
  BankAccountNotFound = 'BankAccountNotFound',
  WireRequestNotFound = 'WireRequestNotFound',
  InvalidWireRequestStatus = 'InvalidWireRequestStatus',
  InvalidWireRequestAmount = 'InvalidWireRequestAmount',
  ItemAlreadyScanned = 'ItemAlreadyScanned',
  OneOrMoreSeatsOccupied = 'OneOrMoreSeatsOccupied',
  VenueSeatLocked = 'VenueSeatLocked',
  VenueNotConverted = 'VenueNotConverted',
  VenueLayoutInvalid = 'VenueLayoutInvalid',
  EventSeatHasSales = 'EventSeatHasSales',
  SectorSeatCountMismatch = 'SectorSeatCountMismatch',
  TableSeatItemsMismatch = 'TableSeatItemsMismatch',
  VenueNotPublished = 'VenueNotPublished',
  EventHasNoSubscribedEvent = 'EventHasNoSubscribedEvent',
  CannotReserveSeatWithNoReservationId = 'CannotReserveSeatWithNoReservationId',
  BankAccountAssociatedWithWireRequests = 'BankAccountAssociatedWithWireRequests',
  BankAccountInactive = 'BankAccountInactive',
  BoardSettlementNotGroup = 'BoardSettlementNotGroup',
  BoardSettlementNothingToSettle = 'BoardSettlementNothingToSettle',
  BoardSettlementTotalMismatch = 'BoardSettlementTotalMismatch',
  WireRequestAmountGreaterThanEventBalanceAndPendingRequests = 'WireRequestAmountGreaterThanEventBalanceAndPendingRequests',
  EmailAlreadyInUse = 'EmailAlreadyInUse',
  MemberRequestNotFound = 'MemberRequestNotFound',
  TicketAlreadySoldToMember = 'TicketAlreadySoldToMember',
  TicketIsMemberExclusiveButPersonIsNotAMember = 'TicketIsMemberExclusiveButPersonIsNotAMember',
  PersonIsAlreadyAMember = 'PersonIsAlreadyAMember',
  SellerGroupNotFound = 'SellerGroupNotFound',
  TicketSellerGroupNotFound = 'TicketSellerGroupNotFound',
  TicketIsEventIdExclusive = 'TicketIsEventIdExclusive',
  ScannerKeyNotFound = 'ScannerKeyNotFound',
  ScannerKeyExpired = 'ScannerKeyExpired',
  ScannerNotAllowedToScanStaffRole = 'ScannerNotAllowedToScanStaffRole',
  ScannerPersonIdSearchDisabled = 'ScannerPersonIdSearchDisabled',
  PayWayTokenRetrievalFailed = 'PayWayTokenRetrievalFailed',
  PayWayPaymentCreationFailed = 'PayWayPaymentCreationFailed',
  PaywayRejectedBySecurity = 'PaywayRejectedBySecurity',
  PaywayCardNotAccepted = 'PaywayCardNotAccepted',
  BinNotFound = 'BinNotFound',
  PaywayPaymentRejected = 'PaywayPaymentRejected',
  PaywayInstallmentsNotAvailable = 'PaywayInstallmentsNotAvailable',
  CashRegisterSessionBalanceInsufficient = 'CashRegisterSessionBalanceInsufficient',
  CashRegisterInactive = 'CashRegisterInactive',
  CashRegisterHasOpenSession = 'CashRegisterHasOpenSession',
  CashRegisterAlreadyOpen = 'CashRegisterAlreadyOpen',
  CashRegisterSessionNotFound = 'CashRegisterSessionNotFound',
  CashRegisterSessionClosed = 'CashRegisterSessionClosed',
  CashRegisterSessionOpenedByAnotherUser = 'CashRegisterSessionOpenedByAnotherUser',
  InPersonSalesNotEnabled = 'InPersonSalesNotEnabled',
  CashierPaymentMethodNotAllowed = 'CashierPaymentMethodNotAllowed',
  OrderDuplicateRequest = 'OrderDuplicateRequest',
  PrintedTicketNotActivated = 'PrintedTicketNotActivated',
  PrintedTicketNotFound = 'PrintedTicketNotFound',
  PrintedTicketAlreadyLinked = 'PrintedTicketAlreadyLinked',
  PrintedTicketCodeAmbiguous = 'PrintedTicketCodeAmbiguous',
  ItemAlreadyHasPrintedTicket = 'ItemAlreadyHasPrintedTicket',
  ItemHasNoPrintedTicket = 'ItemHasNoPrintedTicket',
  ItemAlreadyUsed = 'ItemAlreadyUsed',
  PrintedTicketSaleNotInPerson = 'PrintedTicketSaleNotInPerson',
  PrintedTicketSourceAmbiguous = 'PrintedTicketSourceAmbiguous',
  PrintedTicketRequired = 'PrintedTicketRequired',
  PrivateEventInsufficientBalance = 'PrivateEventInsufficientBalance',
  PrivateEventConfigNotFound = 'PrivateEventConfigNotFound',
  CodeBalanceLoadNotFound = 'CodeBalanceLoadNotFound',
  InvalidCodePackage = 'InvalidCodePackage',
  MinimumInitialLoadNotMet = 'MinimumInitialLoadNotMet',
  InsufficientCodeBalance = 'InsufficientCodeBalance',
  BusinessNotEnabledForPrivateEvents = 'BusinessNotEnabledForPrivateEvents',
  QuickInPersonSalesRequireInPersonSales = 'QuickInPersonSalesRequireInPersonSales',
  CashRegisterWithoutNaveDevice = 'CashRegisterWithoutNaveDevice',
  CashPaymentMethodHasPayments = 'CashPaymentMethodHasPayments',
  CashRegisterTicketNotAllowed = 'CashRegisterTicketNotAllowed',
  CashPaymentMethodRequired = 'CashPaymentMethodRequired',
  HumanVerificationRequired = 'HumanVerificationRequired',
}

const errorMessages: Record<ErrorCode, string> = {
  [ErrorCode.TokenInvalid]: 'Su sesión ha expirado',
  [ErrorCode.EmailNotVerified]: 'Confirmá tu email para continuar',
  [ErrorCode.InvalidBusinessId]: 'ID de productora inválido',
  [ErrorCode.UserHasNoBusiness]: 'El usuario no tiene un productora asociado',
  [ErrorCode.UserDoesNotHavePermissionsForBusiness]: 'No tenés permisos para este productora',
  [ErrorCode.UserDoesNotHavePermissionsForEvent]: 'No tenés permisos para este evento',
  [ErrorCode.ItemDoesNotHaveTicket]: 'El ítem no tiene una entrada asociada',
  [ErrorCode.OrderDoesNotHaveItems]: 'La orden no tiene ítems',
  [ErrorCode.OrderDoesNotHavePayments]: 'La orden no tiene pagos registrados',
  [ErrorCode.OrderDoesNotHavePaymentToReimburse]: 'La orden no tiene pagos para reembolsar',
  [ErrorCode.OrderDoesNotHavePendingPayment]: 'La orden no tiene pagos pendientes',
  [ErrorCode.OrderIdRequired]: 'Se requiere el ID de la orden',
  [ErrorCode.VenueSeatNotFound]: 'Asiento no encontrado',
  [ErrorCode.EventSeatNotFound]: 'Asiento del evento no encontrado',
  [ErrorCode.EventSectorDoesNotBelongToEvent]: 'El sector no pertenece a este evento',
  [ErrorCode.EventHasNoVenue]: 'El evento no tiene sede asignada',
  [ErrorCode.UnknownError]: 'Error desconocido',
  [ErrorCode.UserNotFound]: 'Usuario no encontrado',
  [ErrorCode.EventNotFound]: 'Evento no encontrado',
  [ErrorCode.OrderNotFound]: 'Orden no encontrada',
  [ErrorCode.TicketNotFound]: 'Entrada no encontrada',
  [ErrorCode.ItemNotFound]: 'Ítem no encontrado',
  [ErrorCode.PaymentNotFound]: 'Pago no encontrado',
  [ErrorCode.AgentNotFound]: 'Agente no encontrado',
  [ErrorCode.DecodeError]: 'Código inválido',
  [ErrorCode.QrCodeRevoked]: 'Código anulado',
  [ErrorCode.NoPaidItemsFound]: 'DNI buscado no tiene entradas registradas',
  [ErrorCode.TicketItemsMismatch]: 'Los ítems no coinciden con las entradas',
  [ErrorCode.NoTicketsLeft]: 'No quedan entradas disponibles',
  [ErrorCode.MaxTicketsPerOrderExceeded]: 'Se excedió el máximo de entradas por orden',
  [ErrorCode.MaxItemsPerPersonExceeded]: 'Alcanzaste el máximo de entradas por persona para este evento.',
  [ErrorCode.TicketInactive]: 'La entrada no está activa',
  [ErrorCode.NoCustomPrice]: 'No hay precio personalizado',
  [ErrorCode.InvalidCustomPrice]: 'Precio personalizado inválido',
  [ErrorCode.InvalidCouponEvent]: 'Cupón inválido para este evento',
  [ErrorCode.UserAlreadyInvited]: 'El usuario ya fue invitado',
  [ErrorCode.UserAlreadyInBusiness]: 'El usuario ya pertenece al productora',
  [ErrorCode.InvitationNotFound]: 'Invitación no encontrada',
  [ErrorCode.CodeUsed]: 'Código ya utilizado',
  [ErrorCode.InvalidOrderStatusTransition]: 'Transición de estado de orden inválida',
  [ErrorCode.ItemOtherEvent]: 'La entrada pertenece a otro evento',
  [ErrorCode.ItemDoesNotHaveOrder]: 'El ítem no tiene una orden asociada',
  [ErrorCode.SeatsHaveNoReservationCode]: 'Los asientos no tienen código de reserva',
  [ErrorCode.ReservationNotFound]: 'Reserva no encontrada',
  [ErrorCode.ItemDoesNotHaveSeatOrTicket]: 'El ítem no tiene asiento o entrada asignada',
  [ErrorCode.OrderWithNoItems]: 'Orden sin ítems',
  [ErrorCode.SectorDoesNotMatch]: 'El sector no coincide',
  [ErrorCode.SeatReservationMismatch]: 'La reserva del asiento no coincide',
  [ErrorCode.SeatNotAvailable]: 'Asiento no disponible',
  [ErrorCode.VerificationCodeIncorrect]: 'Código de verificación incorrecto',
  [ErrorCode.BusinessNotFound]: 'Productora no encontrado',
  [ErrorCode.CouponNotFound]: 'Cupón no encontrado',
  [ErrorCode.ReservationExpired]: 'La reserva ha expirado',
  [ErrorCode.EventSectorNotFound]: 'Sector del evento no encontrado',
  [ErrorCode.MercadoPagoPreferenceCreationFailed]: 'Error al crear la preferencia de MercadoPago',
  [ErrorCode.MercadoPagoPaymentRetrievalFailed]: 'Error al obtener el pago de MercadoPago',
  [ErrorCode.UalaTokenRetrievalFailed]: 'Error al obtener el token de Ualá',
  [ErrorCode.UalaPaymentCreationFailed]: 'Error al crear el pago en Ualá',
  [ErrorCode.PollResponsesNotFound]: 'Respuestas de la encuesta no encontradas',
  [ErrorCode.ReferralNotFound]: 'Referido no encontrado',
  [ErrorCode.SeatReservationNotFound]: 'Reserva de asiento no encontrada',
  [ErrorCode.FirebaseIdRequired]: 'Se requiere ID de Firebase',
  [ErrorCode.CodeRequired]: 'Se requiere un código',
  [ErrorCode.PdfGenerationFailed]: 'Error al generar el PDF',
  [ErrorCode.TicketMailGenerationFailed]: 'Error al generar el correo de la entrada',
  [ErrorCode.VenueNotFound]: 'Sede no encontrada',
  [ErrorCode.Unauthorized]: 'No autorizado',
  [ErrorCode.UserEventNotFound]: 'Evento del usuario no encontrado',
  [ErrorCode.UserBusinessNotFound]: 'Productora del usuario no encontrado',
  [ErrorCode.UserDoesNotHavePermissionsForSeller]: 'No tenés permisos para este vendedor',
  [ErrorCode.SellerDoesNotHaveSummary]: 'El vendedor no tiene resumen',
  [ErrorCode.EventTransactionNotFound]: 'Transacción no encontrada',
  [ErrorCode.NoBasePrice]: 'No hay precio base',
  [ErrorCode.ItemNotPaid]: 'El ítem no está pagado',
  [ErrorCode.OrderNotPaid]: 'La orden no está pagada',
  [ErrorCode.FromBackofficeNotAllowed]: 'No se puede acceder desde el backoffice',
  [ErrorCode.InvalidSellerQrCode]: 'Código de vendedor inválido',
  [ErrorCode.UserEventDoesNotBelongToEvent]: 'El evento del usuario no pertenece al evento',
  [ErrorCode.EventDoesNotHaveSellerQr]: 'El evento no tiene código de vendedor',
  [ErrorCode.TicketPrivileged]: 'La entrada es privilegiada',
  [ErrorCode.NotImplemented]: 'No implementado',
  [ErrorCode.PaymentConfigNotFound]: 'Configuración de pago no encontrada',
  [ErrorCode.MercadoPagoAccessTokenCreationFailed]: 'Error al crear el token de MercadoPago',
  [ErrorCode.MercadoPagoAlreadyAuthorized]: 'MercadoPago ya autorizado',
  [ErrorCode.BothEventsSame]: 'Los eventos son los mismos',
  [ErrorCode.WireTransferNotFound]: 'Transferencia no encontrada',
  [ErrorCode.TicketSaleNotStarted]: 'Aun no se puede comprar esta entrada',
  [ErrorCode.TicketSaleEnded]: 'La venta de esta entrada ya finalizó',
  [ErrorCode.ScanPeriodEarly]: 'El código todavía no puede ser escaneado',
  [ErrorCode.ScanPeriodExpired]: 'El código ya expiró',
  [ErrorCode.SeatNotReserved]: 'El asiento no está reservado',
  [ErrorCode.InvalidReservationCode]: 'Código de reserva inválido',
  [ErrorCode.DuplicateSeatsInOrder]: 'Hay asientos duplicados en la orden',
  [ErrorCode.OrderOtherEvent]: 'La compra pertenece a otro evento',
  [ErrorCode.OrderHasNoItems]: 'La compra no tiene ítems',
  [ErrorCode.NoFileProvided]: 'No se envió un archivo',
  [ErrorCode.ErrorUploadingFile]: 'Error al subir el archivo',
  [ErrorCode.SellerSalesNotEnabled]: 'Las ventas no están habilitadas',
  [ErrorCode.CannotUpdatePriceWhenSold]: 'No se puede actualizar el precio porque la entrada ya ha sido vendida',
  [ErrorCode.CannotDeleteReferralWithTicketsSold]: 'No se puede eliminar el referido porque tiene ventas',
  [ErrorCode.CannotDeleteTicketWithTicketsSold]: 'No se puede eliminar la entrada porque tiene ventas',
  [ErrorCode.CouponHasRelatedOrders]: 'El cupón ya se usó en compras: no se puede eliminar, y solo se puede cambiar la cantidad y sumar entradas permitidas',
  [ErrorCode.CouponLimitBelowTaken]: 'La cantidad no puede ser menor a los cupones ya usados',
  [ErrorCode.CannotEditReferralWithTicketsSold]: 'No se puede editar el referido porque tiene ventas',
  [ErrorCode.CannotDeleteSellerWithSales]: 'No se puede eliminar el vendedor porque ya realizó ventas',
  [ErrorCode.CannotUpdateCommissionWithSales]: 'No se puede modificar la comisión del vendedor porque ya realizó ventas',
  [ErrorCode.CommissionNothingToPay]: 'No hay saldo de comisionistas para transferir.',
  [ErrorCode.CommissionBalanceChanged]: 'El saldo cambió por ventas nuevas. Revisá el nuevo total y volvé a confirmar.',
  [ErrorCode.CannotDeleteVenueWithSeats]: 'No se puede eliminar la sede porque tiene asientos',
  [ErrorCode.CannotDeleteEventSectorWithSeats]: 'No se puede eliminar el sector porque tiene asientos',
  [ErrorCode.InvalidId]: 'ID inválido',
  [ErrorCode.TicketBelongsToOtherEvent]: 'La entrada pertenece a otro evento',
  [ErrorCode.OrderDoesNotBelongToEvent]: 'La orden no pertenece al evento',
  [ErrorCode.FirebaseUpdateFailed]: 'Error al actualizar el usuario en Firebase',
  [ErrorCode.UserNotAllowedToAccessResource]: 'El usuario no tiene permisos para acceder a este recurso',
  [ErrorCode.CashierOrderNotAllowed]: 'No se puede crear una orden de caja',
  [ErrorCode.BankAccountNotFound]: 'Cuenta bancaria no encontrada',
  [ErrorCode.WireRequestNotFound]: 'Solicitud de transferencia no encontrada',
  [ErrorCode.InvalidWireRequestStatus]: 'Estado de solicitud de transferencia inválido',
  [ErrorCode.InvalidWireRequestAmount]: 'Monto de solicitud de transferencia inválido',
  [ErrorCode.ItemAlreadyScanned]: 'El ítem ya fue escaneado',
  [ErrorCode.OneOrMoreSeatsOccupied]: 'Uno o más asientos ya están ocupados',
  [ErrorCode.VenueSeatLocked]: 'Hay lugares con ventas: podés cambiarles el nombre, pero no moverlos, cambiarles la medida ni borrarlos.',
  [ErrorCode.VenueNotConverted]: 'Este venue todavía está en el formato viejo. Se convierte a metros al migrar.',
  [ErrorCode.VenueLayoutInvalid]: 'Resolvé los avisos de la revisión antes de publicar.',
  [ErrorCode.EventSeatHasSales]: 'Hay lugares con ventas: no se pueden cambiar de sector ni quitar del mapa.',
  [ErrorCode.SectorSeatCountMismatch]: 'Un sector solo puede tener lugares para la misma cantidad de personas.',
  [ErrorCode.TableSeatItemsMismatch]: 'La mesa se vende entera: tiene que haber una entrada por persona.',
  [ErrorCode.VenueNotPublished]: 'El venue está en borrador: publicalo antes de usarlo en un evento.',
  [ErrorCode.EventHasNoSubscribedEvent]: 'El evento no tiene un evento suscrito',
  [ErrorCode.CannotReserveSeatWithNoReservationId]: 'No se puede reservar un asiento sin ID de reserva',
  [ErrorCode.BankAccountAssociatedWithWireRequests]: 'No se puede eliminar la cuenta bancaria porque tiene solicitudes de transferencia',
  [ErrorCode.BankAccountInactive]: 'La cuenta bancaria no está activa',
  [ErrorCode.BoardSettlementNotGroup]: 'Solo los tableros de tipo grupo admiten liquidación masiva',
  [ErrorCode.BoardSettlementNothingToSettle]: 'Ningún evento del tablero tiene saldo pendiente para liquidar',
  [ErrorCode.BoardSettlementTotalMismatch]: 'El saldo pendiente cambió desde que abriste el tablero. Actualizá y volvé a intentar',
  [ErrorCode.WireRequestAmountGreaterThanEventBalanceAndPendingRequests]: 'Hay solicitudes pendientes por un monto mayor al saldo disponible',
  [ErrorCode.EmailAlreadyInUse]: 'El correo electrónico ya está en uso',
  [ErrorCode.MemberRequestNotFound]: 'Solicitud de socio no encontrada',
  [ErrorCode.TicketAlreadySoldToMember]: 'La entrada ya fue vendida a este socio',
  [ErrorCode.TicketIsMemberExclusiveButPersonIsNotAMember]: 'La entrada es exclusiva para socios y el cliente no es socio',
  [ErrorCode.PersonIsAlreadyAMember]: 'La persona ya es socio o tiene una solicitud pendiente',
  [ErrorCode.SellerGroupNotFound]: 'Grupo de vendedor no encontrado',
  [ErrorCode.TicketSellerGroupNotFound]: 'La entrada no pertenece a este grupo de vendedor',
  [ErrorCode.TicketIsEventIdExclusive]: 'Este DNI no puede comprar esta entrada',
  [ErrorCode.ScannerKeyNotFound]: 'Clave de escáner no encontrada',
  [ErrorCode.ScannerKeyExpired]: 'Clave de escáner expirada',
  [ErrorCode.ScannerNotAllowedToScanStaffRole]: 'El escáner no tiene permisos para escanear este rol de staff',
  [ErrorCode.ScannerPersonIdSearchDisabled]: 'Este evento no permite buscar entradas por DNI',
  [ErrorCode.PayWayTokenRetrievalFailed]: 'Error al obtener el token de PayWay',
  [ErrorCode.PayWayPaymentCreationFailed]: 'Error al crear el pago en PayWay',
  [ErrorCode.PaywayRejectedBySecurity]: 'El pago fue rechazado por motivos de seguridad. Verificá que los datos ingresados sean correctos o probá con otra tarjeta.',
  [ErrorCode.PaywayCardNotAccepted]: 'Esta tarjeta no está habilitada para pagar en este evento. Probá con otra tarjeta.',
  [ErrorCode.BinNotFound]: 'No pudimos identificar el emisor de la tarjeta.',
  // Fallback only: the backend sends the issuer's actual reason in `error`,
  // and the checkout prefers that over this generic text.
  [ErrorCode.PaywayPaymentRejected]: 'El pago fue rechazado por el banco emisor. Probá con otra tarjeta o comunicate con tu banco.',
  [ErrorCode.PaywayInstallmentsNotAvailable]: 'La cantidad de cuotas seleccionada no está disponible para esta tarjeta. Elegí otra opción de cuotas.',
  [ErrorCode.CashRegisterSessionBalanceInsufficient]: 'El efectivo de la caja no es suficiente',
  [ErrorCode.CashRegisterInactive]: 'Esta caja está desactivada. Pedile a un administrador que la active o cerrá la sesión.',
  [ErrorCode.CashRegisterHasOpenSession]: 'Cerrá la caja antes de desactivarla.',
  [ErrorCode.CashRegisterAlreadyOpen]: 'La caja ya está abierta',
  [ErrorCode.CashRegisterSessionNotFound]: 'No se encontró la sesión de caja',
  [ErrorCode.CashRegisterSessionClosed]: 'La caja está cerrada',
  [ErrorCode.CashRegisterSessionOpenedByAnotherUser]: 'La caja está abierta por otro usuario',
  [ErrorCode.InPersonSalesNotEnabled]: 'El evento no acepta ventas presenciales',
  [ErrorCode.CashierPaymentMethodNotAllowed]: 'Esta caja no acepta ese medio de pago. Elegí otro o pedile a un administrador que lo sume a la caja.',
  [ErrorCode.OrderDuplicateRequest]: 'Esta venta ya se registró. Revisá las ventas de la sesión antes de volver a cobrar.',
  [ErrorCode.PrintedTicketNotActivated]: 'Entrada física sin activar',
  [ErrorCode.PrintedTicketNotFound]: 'No es una entrada física de este evento',
  [ErrorCode.PrintedTicketAlreadyLinked]: 'Esta entrada física ya está vinculada a otra venta',
  [ErrorCode.PrintedTicketCodeAmbiguous]: 'Hay más de una entrada física con ese número de orden. Escaneá el QR',
  [ErrorCode.ItemAlreadyHasPrintedTicket]: 'Esta entrada ya tiene una entrada física vinculada',
  [ErrorCode.ItemHasNoPrintedTicket]: 'Esta entrada no tiene una entrada física vinculada',
  [ErrorCode.ItemAlreadyUsed]: 'La entrada ya ingresó al evento y no se puede vincular ni desvincular',
  [ErrorCode.PrintedTicketSaleNotInPerson]: 'Solo se pueden vincular entradas físicas a ventas de caja',
  [ErrorCode.PrintedTicketSourceAmbiguous]: 'No se puede desvincular: hay más de una orden sin pagar con ese número',
  [ErrorCode.PrintedTicketRequired]: 'Elegí un tipo de entrada impresa',
  [ErrorCode.PrivateEventInsufficientBalance]: 'No tenés saldo de códigos suficiente para generar entradas manuales',
  [ErrorCode.PrivateEventConfigNotFound]: 'La configuración de eventos privados no está disponible',
  [ErrorCode.CodeBalanceLoadNotFound]: 'No se encontró la recarga de códigos solicitada',
  [ErrorCode.InvalidCodePackage]: 'El paquete de códigos seleccionado no es válido',
  [ErrorCode.MinimumInitialLoadNotMet]: 'La primera carga no cumple con el mínimo requerido',
  [ErrorCode.InsufficientCodeBalance]: 'No tenés saldo de códigos suficiente para generar entradas manuales',
  [ErrorCode.BusinessNotEnabledForPrivateEvents]: 'Tu productora aún no está habilitada para eventos privados',
  [ErrorCode.QuickInPersonSalesRequireInPersonSales]: 'Para usar la venta rápida, el evento tiene que aceptar ventas presenciales',
  [ErrorCode.CashRegisterWithoutNaveDevice]: 'Esta caja no tiene ese dispositivo de Nave configurado. Cargalo en Editar caja.',
  [ErrorCode.CashPaymentMethodHasPayments]: 'Este medio ya tiene ventas. Desactivalo para que no se ofrezca más.',
  [ErrorCode.CashRegisterTicketNotAllowed]: 'Esta caja no vende esa entrada.',
  [ErrorCode.CashPaymentMethodRequired]: 'Elegí con qué paga el comprador.',
  [ErrorCode.HumanVerificationRequired]: 'No pudimos confirmar que seas una persona. Probá de nuevo en un momento.',
};

const excludedErrors = [
  ErrorCode.BinNotFound,
  ErrorCode.InvalidCouponEvent,
  ErrorCode.ItemAlreadyScanned,
  ErrorCode.TicketBelongsToOtherEvent,
  ErrorCode.OrderDoesNotBelongToEvent,
  ErrorCode.ItemOtherEvent,
  ErrorCode.MemberRequestNotFound,
  ErrorCode.PrivateEventInsufficientBalance,
  ErrorCode.InsufficientCodeBalance,
  // Answered by the "confirm your email" screen, not by a toast.
  ErrorCode.EmailNotVerified,
  // Answered by the Turnstile challenge (useCreateBusinessVerified); it toasts only if that fails.
  ErrorCode.HumanVerificationRequired,
];

const parseErrors = (errorData: ErrorResponse | null | undefined) => {
  // Network failures and non-JSON responses reach here without a body;
  // guard instead of crashing (a TypeError here used to swallow the real
  // error and surface a useless generic toast).
  if (!errorData || typeof errorData !== 'object') {
    return '';
  }
  const code = errorData.code as keyof typeof errorMessages;
  if (excludedErrors.includes(code)) {
    return '';
  }
  return errorMessages[code] || errorData.error;
};

export default parseErrors;
